import isEmail from 'validator/lib/isEmail'
import axios, { AxiosResponse } from 'axios'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { TFunction } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { clearProfileData } from '../../redux/action/profile'
import { generateRefCode } from '../../util/utilityFunction'
import useLoadingStore from '../../stores/useLoadingStore'
import useRelogin from '../useRelogin'
import ConfigAPI from '../../constant/ConfigAPI'

export type Response = { result?: AxiosResponse<any>; error?: any }

export interface Form {
    email?: string
    otp?: string
}

export const validate = async (values: Form, t: TFunction<'translation'>) => {
    const errors: Partial<Form> = {}
    if (!values.email) {
        errors.email = `${t('LABEL.TEXT_REQUIRED')}`
    }
    if (values.email && !isEmail(values.email)) {
        errors.email = `${t('VALIDATE.MESSAGES.EMAIL')}`
    }
    return errors
}

const useVerify = () => {
    const [openDialogOk, setOpenDialogOk] = useState<boolean>(false)
    const [alertMessageOk, setAlertMessageOk] = useState<string>('')
    const [openDialogError, setOpenDialogError] = useState<boolean>(false)
    const [alertMessageError, setAlertMessageError] = useState<string>('')
    const [disabledEmail, setDisabledEmail] = useState(false)
    const [disabledOTP, setDisabledOTP] = useState(true)
    const [refCode, setRefCode] = useState<string>('')
    const [statusCode, setStatusCode] = useState<number>()
    const [stationId, setStationId] = useState<number>()
    const { reLoginForTokenExpired, callServiceReLogin } = useRelogin()
    const loadingStore = useLoadingStore()
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        const splitUrl = globalThis.location.href.split('/')
        const stationId = splitUrl.pop()
        if (stationId) {
            setStationId(parseInt(stationId))
        }
    }, [])

    const callServiceRequestOTP = async (email: string, refCode: string) => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/feedback/requestOTP`
            const reqParams = { email, refCode }
            const result = await axios.post(url, reqParams, ConfigAPI)
            if (result.status === 200) {
                setStatusCode(200.1)
                setRefCode(refCode)
                setDisabledEmail(true)
                setDisabledOTP(false)
                setOpenDialogOk(true)
                setAlertMessageOk('รหัส OTP ถูกส่งเข้าอีเมลของท่าน กรุณาตรวจสอบ')
            }
            return { result }
        } catch (error) {
            //@ts-ignore
            const errMsg: string = error?.toString()
            if (errMsg) {
                setStatusCode(401.1)
                setOpenDialogOk(true)
                setAlertMessageOk('ไม่สามารถส่งอีเมล เพื่อขอรหัส OTP ได้')
            }
            return { error }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const callServiceVerifyOTP = async (email: string, otp: string, refCode: string) => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/feedback/verifyOTP`
            const reqParams = { email, otp, refCode }
            const result = await axios.post(url, reqParams, ConfigAPI)
            if (result.status === 200) {
                if (result.data.message) {
                    setStatusCode(401.2)
                    setOpenDialogOk(true)
                    setAlertMessageOk('รหัส OTP ไม่ถูกต้อง')
                } else {
                    setStatusCode(200.2)
                    setOpenDialogOk(true)
                    setAlertMessageOk('ยืนยันตัวตนสำเร็จ')
                    globalThis.sessionStorage.setItem(`${process.env.REACT_APP_ACCESS_TOKEN_USER}`, result.data.otk)
                    globalThis.sessionStorage.setItem(`${process.env.REACT_APP_ACCESS_TOKEN_NBTC}`, result.data.otk)
                }
            }
            return { result }
        } catch (error) {
            //@ts-ignore
            const errMsg: string = error?.toString()
            if (errMsg) {
                if (errMsg.includes('401')) {
                    //reLoginForTokenExpired()
                    //callServiceReLogin()
                } else {
                    setStatusCode(500)
                    setOpenDialogError(true)
                    setAlertMessageError('ยืนยันตัวตนไม่สําเร็จ')
                }
            }
            return { error }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const handleSubmitForm = (values: Form) => {
        if (values.email && values.otp && values.otp?.length === 6) {
            callServiceVerifyOTP(values.email, values.otp, refCode)
        } else if (values.email) {
            if (refCode) {
                values.otp = ''
                setRefCode('')
                setDisabledOTP(true)
                setDisabledEmail(false)
            } else {
                callServiceRequestOTP(values.email, generateRefCode(4))
            }
        }
    }

    const handleClickOk = () => {
        setOpenDialogOk(false)
        setOpenDialogError(false)
        if (statusCode !== 200.1 && statusCode !== 401.2) {
            if (statusCode === 200.2) {
                history.push(`/feedback/${stationId}`)
            } else {
                history.push('/')
            }
        }
    }

    return {
        onSubmitForm: handleSubmitForm,
        onClickOk: handleClickOk,
        openDialogOk,
        alertMessageOk,
        openDialogError,
        alertMessageError,
        disabledEmail,
        disabledOTP,
        refCode,
    }
}

export default useVerify
